export default __webpack_public_path__ + "static/media/back_new.d282f249.svg";